import { categoryConstants } from "./constants";
import axiosInstance from "../helpers/axios";
import toast from "react-hot-toast";

export const getAllCategories = () => {
  return async (dispatch) => {
    dispatch({ type: categoryConstants.GET_CATEGORIES_REQUEST });
    try {
      const res = await axiosInstance.get("/admin/services/category/get-all");
      if (res.status === 200) {
        const { categories } = res.data;
        dispatch({
          type: categoryConstants.GET_CATEGORIES_SUCCESS,
          payload: { categories },
        });
      } else {
        dispatch({
          type: categoryConstants.GET_CATEGORIES_FAILURE,
          payload: { error: res.data.error },
        });
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      dispatch({
        type: categoryConstants.GET_CATEGORIES_FAILURE,
        payload: { error: error.message },
      });
    }
  };
};

export const createCategory = (form) => {
  return async (dispatch) => {
    dispatch({ type: categoryConstants.CREATE_CATEGORY_REQUEST });
    try {
      const res = await axiosInstance.post(
        "/admin/services/category/create",
        form,
      );
      if (res.status === 201) {
        const { category } = res.data;
        dispatch({
          type: categoryConstants.CREATE_CATEGORY_SUCCESS,
          payload: { category },
        });
        toast.success("Category created successfully");
      } else {
        dispatch({
          type: categoryConstants.CREATE_CATEGORY_FAILURE,
          payload: { error: res.data.error },
        });
      }
    } catch (error) {
      const data = error?.response?.data;
      dispatch({
        type: categoryConstants.CREATE_CATEGORY_FAILURE,
        payload: { error: error.message },
      });
      toast.error(`${data?.msg || "Error creating category"}`);
    }
  };
};

export const deleteCategory = (categoryId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: categoryConstants.DELETE_CATEGORY_REQUEST });
      const res = await axiosInstance.delete(
        `/admin/services/category/delete/${categoryId}`,
      );
      if (res.status === 200) {
        dispatch({
          type: categoryConstants.DELETE_CATEGORY_SUCCESS,
          payload: { categoryId },
        });
        toast.success("Category deleted successfully");
      } else {
        dispatch({
          type: categoryConstants.DELETE_CATEGORY_FAILURE,
          payload: { error: res.data.error },
        });
      }
    } catch (error) {
      dispatch({
        type: categoryConstants.DELETE_CATEGORY_FAILURE,
        payload: { error: error.message },
      });
      toast.error("Error deleting category");
    }
  };
};
